import { useSelector } from 'react-redux';
import type { RootState } from '@/state/store';

export const usePermission = () => {
  const permissions = useSelector((state: RootState) => state.auth.user?.permissions ?? []);

  const hasPermission = (code: string): boolean =>
    permissions.some((p) => p.toLowerCase() === code.toLowerCase());

  const hasAnyPermission = (...codes: string[]): boolean =>
    codes.some((code) => hasPermission(code));

  const hasAllPermissions = (...codes: string[]): boolean =>
    codes.every((code) => hasPermission(code));

  return { hasPermission, hasAnyPermission, hasAllPermissions, permissions };
};
